import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

/**
 * Clickable table column header used inside a `<th>`. Renders a right-aligned
 * label + sort direction indicator and toggles the shared `useSort` state.
 *
 *   <SortHeader label="Revenue" k="revenue" state={sort} testId="best-sort-revenue" />
 */
export function SortHeader({ label, k, state, align = "right", testId }) {
  const active = state.sortKey === k;
  const Icon = !active ? ArrowUpDown : state.sortDir === "desc" ? ArrowDown : ArrowUp;
  return (
    <button
      type="button"
      onClick={() => state.toggle(k)}
      className={`bm-eyebrow inline-flex items-center gap-1 w-full hover:text-[#0a0a0a] ${
        align === "right" ? "justify-end" : align === "center" ? "justify-center" : "justify-start"
      } ${active ? "text-[#0a0a0a] font-semibold" : "text-neutral-500"}`}
      title={`Sort by ${label}`}
      data-testid={testId}
    >
      {label}
      <Icon
        size={10}
        className={active ? "text-[#0a0a0a]" : "text-neutral-400"}
        strokeWidth={active ? 2.5 : 2}
      />
    </button>
  );
}

/**
 * Compact chip-bar variant used for card-list layouts (Best Sellers,
 * On the Rise, etc.) where there are no column headers to click.
 *
 *   <SortChips
 *     state={sort}
 *     options={[
 *       { k: "units", label: "Units" },
 *       { k: "growth", label: "Δ" },
 *       { k: "avg_price", label: "Avg $" },
 *       { k: "revenue", label: "Revenue" },
 *     ]}
 *     testIdPrefix="best-sort"
 *   />
 */
export function SortChips({ state, options, testIdPrefix }) {
  return (
    <div className="flex items-center gap-1 flex-wrap" role="group" aria-label="Sort by">
      <span className="bm-eyebrow text-neutral-500 mr-1">Sort</span>
      <div className="flex border border-[#0a0a0a]">
        {options.map((o, i) => {
          const active = state.sortKey === o.k;
          const Icon = !active ? ArrowUpDown : state.sortDir === "desc" ? ArrowDown : ArrowUp;
          return (
            <button
              key={o.k}
              type="button"
              onClick={() => state.toggle(o.k)}
              className={`px-2 py-1 bm-eyebrow inline-flex items-center gap-1 ${
                i > 0 ? "border-l border-[#0a0a0a]" : ""
              } ${active ? "bg-[#0a0a0a] text-[#f5f2eb]" : "hover:bg-[#0a0a0a]/5"}`}
              data-testid={`${testIdPrefix}-${o.k}`}
              title={`Sort by ${o.label}`}
            >
              {o.label}
              <Icon size={10} strokeWidth={active ? 2.5 : 2} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
